"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1814],{

/***/ 1814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BackgroundGoogleAds; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/lib/ads.ts
var ads = __webpack_require__(4498);
// EXTERNAL MODULE: ./src/hooks/useScriptFlag.ts
var useScriptFlag = __webpack_require__(1436);
;// CONCATENATED MODULE: ./src/hooks/useAdSlot.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 


function useAdSlot(param) {
    var adType = param.adType, isTransitioning = param.isTransitioning, hash = param.hash, _isSponsored = param.isSponsored, isSponsored = _isSponsored === void 0 ? undefined : _isSponsored;
    var tag = "div-gpt-ad-".concat(adType, "-").concat(hash);
    var shouldRenderAds = (0,useScriptFlag/* default */.Z)({
        adFlag: "google"
    });
    (0,react.useEffect)(function() {
        if (isTransitioning || "object" === undefined || !shouldRenderAds) {
            return;
        }
        var googletag = window.googletag, apstag = window.apstag;
        googletag.cmd.push(function() {
            var slotGt = googletag.defineSlot("/22189562696/".concat(adType), (0,ads/* getSizesByAdType */.V)(adType), "".concat(tag)).addService(googletag.pubads());
            googletag.display(tag);
            if (adType === "background/topo-mobile") {
                apstag.fetchBids({
                    slots: [
                        {
                            slotID: tag,
                            slotName: "/22189562696/".concat(adType),
                            sizes: (0,ads/* getSizesByAdType */.V)(adType)
                        }, 
                    ]
                }, function(_bids) {
                    googletag.cmd.push(function() {
                        apstag.setDisplayBids();
                        googletag.pubads().refresh([
                            slotGt
                        ]);
                    });
                });
            } else {
                googletag.pubads().refresh([
                    slotGt
                ]);
            }
        });
    }, [
        adType,
        isTransitioning,
        tag
    ]);
    (0,react.useEffect)(function() {
        if (isSponsored == undefined) return;
        var googletag = window.googletag;
        var REFRESH_KEY = "refresh";
        var REFRESH_VALUE = isSponsored ? "false" : "true";
        var definedSlotIndex = googletag.pubads().getSlots().findIndex(function(slot) {
            return slot.getAdUnitPath() === "/22189562696/".concat(adType);
        });
        definedSlotIndex > -1 && googletag.pubads().getSlots()[definedSlotIndex].setTargeting(REFRESH_KEY, REFRESH_VALUE).setTargeting("refreshed_slot", "false");
    }, [
        isSponsored
    ]);
}
/* harmony default export */ var hooks_useAdSlot = (useAdSlot);

// EXTERNAL MODULE: ./src/hooks/useBreakpoint.ts
var useBreakpoint = __webpack_require__(2140);
// EXTERNAL MODULE: ./src/hooks/useTransition.tsx
var useTransition = __webpack_require__(976);
;// CONCATENATED MODULE: ./src/components/Ads/Google/BackgroundGoogleAds/index.tsx






var hashId = "7854219864518745523415628";
var possibleSizes = [
    970,
    728,
    320,
    300
];
function BackgroundGoogleAds() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("tablet"), 1), isMobile = ref[0];
    var isTransitioning = (0,useTransition/* useTransition */.Y)().isTransitioning;
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(), adType = ref2[0], setAdType = ref2[1];
    var ref3 = (0,react.useState)(), isSponsored = ref3[0], setIsSponsored = ref3[1];
    var desktopBackgroundRef = (0,react.useRef)(null);
    var mobileBackgroundRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var target = isMobile ? mobileBackgroundRef === null || mobileBackgroundRef === void 0 ? void 0 : mobileBackgroundRef.current : desktopBackgroundRef === null || desktopBackgroundRef === void 0 ? void 0 : desktopBackgroundRef.current;
        var config = {
            childList: true,
            subtree: true
        };
        var callback = function(mutationList) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = mutationList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var mutation = _step.value;
                    var ref;
                    var currentNode = mutation === null || mutation === void 0 ? void 0 : (ref = mutation.addedNodes) === null || ref === void 0 ? void 0 : ref[0];
                    if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.tagName) === "IFRAME" && Number(currentNode === null || currentNode === void 0 ? void 0 : currentNode.width) === 2000) {
                        setIsSponsored(true);
                    } else if (possibleSizes.includes(Number(currentNode === null || currentNode === void 0 ? void 0 : currentNode.width))) {
                        setIsSponsored(false);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        var observer = new MutationObserver(callback);
        observer.observe(target, config);
        return function() {
            observer.disconnect();
        };
    }, [
        isMobile
    ]);
    (0,react.useEffect)(function() {
        if (isMobile) setAdType("topo-mobile");
        else if (!isMobile && isMobile != null) setAdType("bg-topo-desktop");
        if (isLoading && isMobile != null) setIsLoading(false);
    }, [
        isMobile
    ]);
    hooks_useAdSlot({
        adType: "background/".concat(adType),
        isTransitioning: isLoading || isTransitioning,
        hash: hashId,
        isSponsored: isSponsored
    });
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTopAds, {
        ref: mobileBackgroundRef
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopBackgroundAds, {
        ref: desktopBackgroundRef
    });
}
var MobileTopAds = /*#__PURE__*/ (0,react.forwardRef)(function MobileTopAds(_, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute bottom-0 left-0 top-[60px] flex h-[100px] w-full items-center justify-center has-[iframe[width='2000']]:fixed has-[iframe[width='2000']]:items-start tablet:left-[60px] tablet:top-0 tablet:w-[calc(100%_-_60px)] [&>span]:has-[iframe]:hidden [&_iframe[width='2000']]:absolute [&_iframe]:relative [&_iframe]:w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: ref,
            className: "bg-ad active relative flex items-start justify-center",
            id: "div-gpt-ad-background/topo-mobile-".concat(hashId),
            "data-ad": "true"
        })
    });
});
var DesktopBackgroundAds = /*#__PURE__*/ (0,react.forwardRef)(function DesktopBackgroundAds(_, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute left-0 top-0 flex h-[250px] w-full items-center justify-center has-[iframe[width='2000']]:fixed has-[iframe[width='2000']]:h-screen tablet:left-[60px] tablet:w-[calc(100%_-_60px)] [&_iframe[width='2000']]:absolute [&_iframe[width='2000']]:h-full [&_iframe[width='2000']]:w-full [&_iframe]:relative [&_iframe]:left-0 [&_iframe]:top-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: ref,
            className: "bg-ad active",
            id: "div-gpt-ad-background/bg-topo-desktop-".concat(hashId),
            "data-ad": "true"
        })
    });
});


/***/ }),

/***/ 4498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getSizesByAdType; },
/* harmony export */   "u": function() { return /* binding */ getDevicesByAdType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9815);
/* eslint-disable @typescript-eslint/ban-types */ 
var billboardSizesDefault = [
    [
        970,
        90
    ],
    [
        728,
        90
    ],
    [
        970,
        250
    ], 
];
var rectangleSizesDefault = [
    [
        300,
        250
    ],
    [
        336,
        280
    ], 
];
var rectangleSizesDefaultPlus = [
    [
        160,
        600
    ],
    [
        300,
        50
    ],
    [
        300,
        75
    ],
    [
        300,
        100
    ],
    [
        300,
        600
    ],
    [
        320,
        50
    ],
    [
        320,
        100
    ],
    [
        320,
        480
    ], 
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(rectangleSizesDefault));
var AdsDefs = {
    billboard: {
        sizes: billboardSizesDefault,
        enableMobile: false,
        enableDesktop: true,
        children: {
            main: {
                children: {
                    home: {
                        sizes: billboardSizesDefault,
                        enableMobile: false,
                        enableDesktop: true
                    },
                    listing: {
                        sizes: billboardSizesDefault,
                        enableMobile: false,
                        enableDesktop: true
                    }
                }
            },
            footer: {
                sizes: billboardSizesDefault,
                enableMobile: false,
                enableDesktop: true
            }
        }
    },
    rectangle: {
        children: {
            main: {
                children: {
                    home: {
                        sizes: rectangleSizesDefaultPlus,
                        enableMobile: true,
                        enableDesktop: false
                    },
                    listing: {
                        sizes: rectangleSizesDefaultPlus,
                        enableMobile: true,
                        enableDesktop: false
                    },
                    internal: {
                        sizes: rectangleSizesDefaultPlus,
                        enableMobile: true,
                        enableDesktop: true
                    }
                }
            },
            side: {
                sizes: rectangleSizesDefault,
                enableMobile: false,
                enableDesktop: true
            },
            footer: {
                sizes: rectangleSizesDefaultPlus,
                enableMobile: true,
                enableDesktop: false
            },
            collector: {
                sizes: rectangleSizesDefault,
                enableMobile: true,
                enableDesktop: true
            }
        }
    },
    halfpage: {
        sizes: [
            [
                300,
                600
            ],
            [
                120,
                600
            ],
            [
                160,
                600
            ]
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(rectangleSizesDefault)),
        enableMobile: false,
        enableDesktop: true
    },
    background: {
        children: {
            "bg-topo-desktop": {
                sizes: [
                    [
                        2000,
                        750
                    ]
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(billboardSizesDefault)),
                enableMobile: false,
                enableDesktop: true
            },
            "topo-mobile": {
                sizes: [
                    [
                        2000,
                        750
                    ],
                    [
                        300,
                        50
                    ],
                    [
                        300,
                        100
                    ],
                    [
                        320,
                        50
                    ],
                    [
                        320,
                        100
                    ], 
                ],
                enableMobile: true,
                enableDesktop: false
            }
        }
    },
    anchor: {
        sizes: [
            [
                320,
                50
            ],
            [
                300,
                50
            ],
            [
                1,
                1
            ]
        ],
        enableMobile: true,
        enableDesktop: false
    },
    Anchor_Footer: {
        sizes: [
            [
                728,
                90
            ],
            [
                970,
                90
            ],
            [
                1,
                1
            ]
        ],
        enableMobile: false,
        enableDesktop: true
    },
    Interstitial_2023: {
        sizes: [
            [
                336,
                280
            ],
            [
                300,
                250
            ],
            [
                320,
                480
            ], 
        ],
        enableMobile: true,
        enableDesktop: true
    },
    "1x1": {
        sizes: [
            [
                1,
                1
            ]
        ],
        enableMobile: true,
        enableDesktop: true
    }
};
function getSizesByAdType(adType) {
    var adTypeSplit = adType.replace(/-\d+$/, "").split("/");
    var sizes = [
        []
    ];
    var currentObj = AdsDefs;
    adTypeSplit.forEach(function(key, index) {
        var ref;
        if (((ref = currentObj[key]) === null || ref === void 0 ? void 0 : ref.children) && index < adTypeSplit.length - 1) {
            var ref1;
            currentObj = (ref1 = currentObj[key]) === null || ref1 === void 0 ? void 0 : ref1.children;
        } else {
            var ref2;
            sizes = (ref2 = currentObj[key]) === null || ref2 === void 0 ? void 0 : ref2.sizes;
        }
    });
    return sizes;
}
function getDevicesByAdType(adType) {
    var adTypeSplit = adType.replace(/-\d+$/, "").split("/");
    var devices;
    var currentObj = AdsDefs;
    adTypeSplit.forEach(function(key, index) {
        var ref;
        if (((ref = currentObj[key]) === null || ref === void 0 ? void 0 : ref.children) && index < adTypeSplit.length - 1) {
            var ref1;
            currentObj = (ref1 = currentObj[key]) === null || ref1 === void 0 ? void 0 : ref1.children;
        } else {
            var ref2, ref3;
            devices = {
                desktop: (ref2 = currentObj[key]) === null || ref2 === void 0 ? void 0 : ref2.enableDesktop,
                mobile: (ref3 = currentObj[key]) === null || ref3 === void 0 ? void 0 : ref3.enableMobile
            };
        }
    });
    return devices;
}


/***/ })

}]);